import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import { AuthProvider, Protected } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import PejabatStruktural from "@/pages/PejabatStruktural";
import ProfilPpid from "@/pages/ProfilPpid";
import StrukturPpid from "@/pages/StrukturPpid";
import Pengumuman from "@/pages/Pengumuman";
import StandarPelayanan from "@/pages/StandarPelayanan";
import Lhkpn from "@/pages/Lhkpn";
import PengajuanInformasi from "@/pages/PengajuanInformasi";
import Keberatan from "@/pages/Keberatan";
import Sengketa from "@/pages/Sengketa";
import SaluranPengaduan from "@/pages/SaluranPengaduan";
import DaftarInformasiPublik from "@/pages/DaftarInformasiPublik";
import DataPermohonan from "@/pages/DataPermohonan";
import IndeksKepuasanMasyarakat from "@/pages/IndeksKepuasanMasyarakat";
import DataLaporanPage, { DATA_LAPORAN } from "@/pages/DataLaporan";
import Apik from "@/pages/Apik";
import MonevKartu from "@/pages/MonevKartu";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";

function SmoothScroll() {
  React.useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-white px-6 py-10 text-sm font-semibold text-slate-500">
          Terjadi kesalahan pada tampilan. Muat ulang halaman.
        </div>
      );
    }
    return this.props.children;
  }
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: proses session_id OAuth lebih dulu, secara sinkron saat render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideChrome = ["/login", "/admin", "/dashboard", "/monev/"].some((p) =>
    location.pathname.startsWith(p),
  );
  return (
    <>
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pejabat-struktural" element={<PejabatStruktural />} />
        <Route path="/profil-ppid" element={<ProfilPpid />} />
        <Route path="/struktur-ppid" element={<StrukturPpid />} />
        <Route path="/pengumuman" element={<Pengumuman />} />
        <Route path="/standar-pelayanan" element={<StandarPelayanan />} />
        <Route path="/lhkpn" element={<Lhkpn />} />
        <Route path="/pengajuan-informasi" element={<PengajuanInformasi />} />
        <Route path="/pengajuan-keberatan" element={<Keberatan />} />
        <Route path="/penyelesaian-sengketa" element={<Sengketa />} />
        <Route path="/saluran-pengaduan" element={<SaluranPengaduan />} />
        <Route
          path="/daftar-informasi-publik"
          element={<DaftarInformasiPublik />}
        />
        <Route path="/data-permohonan" element={<DataPermohonan />} />
        <Route
          path="/indeks-kepuasan-masyarakat"
          element={<IndeksKepuasanMasyarakat />}
        />
        <Route path="/login" element={<Login />} />
        {DATA_LAPORAN.map(({ path, title, Icon, kind }) => (
          <Route
            key={path}
            path={path}
            element={<DataLaporanPage title={title} Icon={Icon} kind={kind} />}
          />
        ))}
        <Route
          path="/admin"
          element={
            <Protected role="ppid">
              <Apik />
            </Protected>
          }
        />
        <Route path="/monev/:code" element={<MonevKartu />} />
        <Route
          path="/dashboard"
          element={
            <Protected>
              <Apik />
            </Protected>
          }
        />
      </Routes>
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SmoothScroll />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
